import { ConfigurationType } from '@icc/common/configurations/configurations.service';

export abstract class CurrentConfiguratorService {
    conf: ConfigurationType;

    abstract changeConfigurator(conf: ConfigurationType);

    abstract setConfigurator(config: ConfigurationType);
}
